import {ActionTypes} from './../../cc-imports'
import _ from 'lodash';

const initialState = {
    cache : {},
};


const CacheReducers = (state = initialState, action = {}) => {

    switch (action.type) {
        case (ActionTypes.ADD_TO_CACHE) :
            var cache=state.cache;
            cache[action.payload.key]=action.payload.value;
            return {...state, cache};
        case (ActionTypes.REMOVE_FROM_CACHE) :
            var cache=state.cache;
            cache[action.payload.key]=undefined;
            return {...state, cache};
        default :
            return state;
    }
};

export default CacheReducers;



// WEBPACK FOOTER //
// ./src/app/data/reducers/CacheReducers.js